// Вкладка History в карточке: тот же список по одной строке (table + id), без названия объекта, с откатом своих.
import { useMemo } from 'react';
import { useToast } from '../roadmap/shared/interaction';
import { HistoryList } from './HistoryList';
import { useHistory } from './useHistory';
import { useRevert } from './revert';

export function ObjectHistory({ table, id, active }: { table: string; id: string; active: boolean }) {
  const filter = useMemo(() => ({ table, row: id }), [table, id]);
  const { actions, rows, loadMore, hasMore, loading, error, reload } = useHistory(filter);
  const { fail } = useToast();
  const { revertOf, revertActionOf, revertedBy, actorOf, resolve } = useRevert({ rows, reload, fail });
  return (
    <div data-object-history={id} data-active={active || undefined}>
      <HistoryList actions={actions} resolve={resolve} actorOf={actorOf} hasMore={hasMore} loading={loading} error={error} onMore={loadMore}
        compact revert={revertOf} revertAction={revertActionOf} revertedBy={revertedBy} empty="No changes recorded for this object." />
    </div>
  );
}
